<template>
  <div class="harlequin" aria-hidden="true"></div>
</template>

<script>
export default {
  name: 'HarlequinBorder',
}
</script>

<style scoped>
/* Alternating solid / outlined diamonds, repeated across the full width. */
.harlequin {
  height: 14px;
  background-repeat: repeat-x;
  background-size: 40px 14px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='14' viewBox='0 0 40 14'%3E%3Cpath d='M10 0 20 7 10 14 0 7Z' fill='%23A4492B'/%3E%3Cpath d='M30 1.2 38.3 7 30 12.8 21.7 7Z' fill='none' stroke='%23A4492B' stroke-width='1.2'/%3E%3C/svg%3E");
}
</style>
